import React from 'react';
import GeneralContent from "./general-content.jsx";
import TemporalContent from "./temporal-content.jsx";

const ReportContent = ({ data, collapsed, startDate, endDate }) => {
    return (
        <>
            <GeneralContent key={`general-${collapsed}`} data={data} collapsed={collapsed}/>
            <TemporalContent key={`temporal-${collapsed}`} data={data} collapsed={collapsed} startDate={startDate} endDate={endDate}/>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;